/**
 * Хост формы ОСАГО, которая грузится в iframe превью.
 *
 * По умолчанию определяется окружением сборки:
 *   dev  → VITE_API_URL из .env.development  (https://dev.osagotop.ru)
 *   production   → VITE_API_URL из .env.production   (https://osagotop.ru)
 *
 * Флаг VITE_USE_LOCAL_OSAGO=true переключает на локально поднятый client
 * (по умолчанию http://localhost:8000, переопределяется VITE_LOCAL_OSAGO_URL).
 * Работает только в dev-сборке — в проде игнорируется, чтобы флаг,
 * забытый в .env, не увёл прод на localhost.
 */

const DEFAULT_LOCAL_OSAGO = "http://localhost:8000";

const stripSlash = (url: string) => url.replace(/\/$/, "");

const useLocalOsago =
  import.meta.env.MODE !== "production" &&
  import.meta.env.VITE_USE_LOCAL_OSAGO === "true";

export const WIDGET_HOST = stripSlash(
  useLocalOsago
    ? import.meta.env.VITE_LOCAL_OSAGO_URL || DEFAULT_LOCAL_OSAGO
    : import.meta.env.VITE_API_URL || "https://osagotop.ru",
);

export const EMBED_HOST =
  typeof window !== "undefined" ? window.location.origin : WIDGET_HOST;

/**
 * Публичный API — из него берётся список страховых компаний для конструктора
 * реферальных ссылок. Тот же адрес, что использует osago-client.
 */
export const PUBLIC_API_URL = stripSlash(
  import.meta.env.VITE_PUBLIC_API_URL || "https://dev.api.osagotop.ru/api",
);
